import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { AnchoredAlert } from '../AnchoredAlert';
import styles from './EmissorRechargeReportToast.module.css';
const REPORT_ALERT_DURATION_SECONDS = 8;
const TEST_ID_PREFIX = 'EmissorRechargeReportToast';
const ALERT_MESSAGE_KEYS = {
    empty: 'benefits.orders.recharge-report.alert.empty',
    'limit-exceeded': 'benefits.orders.recharge-report.alert.limit-exceeded',
    'contract-not-found': 'benefits.orders.recharge-report.alert.contract-not-found',
    'invalid-input': 'benefits.orders.recharge-report.alert.invalid-input',
    error: 'benefits.orders.recharge-report.alert.error',
};
const BY_ORDER_ALERT_MESSAGE_KEYS = {
    'limit-exceeded': 'benefits.orders.recharge-report.alert.limit-exceeded-by-order',
    'invalid-input': 'benefits.orders.recharge-report.alert.invalid-input-by-order',
};
const ALERT_TEST_IDS = {
    empty: 'Empty',
    'limit-exceeded': 'LimitExceeded',
    'contract-not-found': 'ContractNotFound',
    'invalid-input': 'InvalidInput',
    error: 'Error',
};
export function EmissorRechargeReportToast({ flow }) {
    const { t } = useTranslation();
    if (!flow.alert) {
        return null;
    }
    const messageKey = (flow.modality === 'orders' ? BY_ORDER_ALERT_MESSAGE_KEYS[flow.alert] : undefined) ??
        ALERT_MESSAGE_KEYS[flow.alert];
    return (_jsx(AnchoredAlert, { testId: `alert${TEST_ID_PREFIX}${ALERT_TEST_IDS[flow.alert]}`, message: t(messageKey), appearance: 'error', duration: REPORT_ALERT_DURATION_SECONDS, onClose: flow.dismissAlert, className: styles.aboveDrawer }));
}
